import { type FC } from 'react';
import {
  Users
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconUsersProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconUsers: FC<UiIconUsersProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Users}
      {...props}
    />
  );
};
